import React, { FC, CSSProperties } from "react"
import styled from "styled-components"
import { toRem } from "../../../utils/styles-function"

const ButtonStyle = styled.div`
  button {
    background: #21a038;
    color: white;
    font-size: ${toRem(13)};
    line-height: ${toRem(18)};
    font-weight: 600;
    border: none;
    border-radius: 3px;
    padding: 7px 12px;
    cursor: pointer;
    transition: 0.225s ease;

    &:hover {
      background: #00d900;
    }

    &:active {
      background: #15a144;
    }

    &:disabled {
      color: #cdd2d6;
      background: #f0f3f6;
    }
  }
`

interface IButton {
  onClick?: () => void
  disabled?: boolean
  style?: CSSProperties
}

const Button: FC<IButton> = ({ children, ...rest }) => {
  return (
    <ButtonStyle>
      <button {...rest}>{children}</button>
    </ButtonStyle>
  )
}

export default Button
